import Signup from './container'

export default Signup
